import Checkbox from 'tio-ui/components/checkbox';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { saveRecord, deleteExistingRecord } from 'tio-data/requests/save-record';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { Store } from '@warp-drive/core';
import type { Tag } from 'tio-data/data/resources/tag.type';

export interface TermVerifiedSignature {
  Args: {
    employee: EmployeeModel;
  };
  Element: HTMLDivElement;
}

export default class TermVerified extends Component<TermVerifiedSignature> {
  @service declare store: Store;

  toggleTermVerified = async () => {
    if (this.args.employee.isTermVerified) {
      const tag = this.args.employee.tags.find((tag) => tag.name === 'Term Verified');
      if (tag) {
        await deleteExistingRecord(this.store, tag);
      }
    } else {
      const tag = this.store.createRecord<Tag>('tag', {
        name: 'Term Verified',
        // @ts-expect-error: polymorphic belongsTo — an Employee isn't structurally a Taggable
        taggable: this.args.employee,
      });
      await saveRecord(this.store, tag);
      return tag;
    }
  };

  <template>
    <Checkbox
      data-term-verified-checkbox
      @label="Term Verified"
      @onChange={{this.toggleTermVerified}}
      @checked={{@employee.isTermVerified}}
      @size="lg"
    />
  </template>
}
